import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimerFormatPipe } from './timer-format.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [ TimerFormatPipe ],
	exports: [ TimerFormatPipe ]
})
export class SharedPipesModule { }
